<mat-dialog-content class="custom-dialog-container">
  <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" [name]="'Mktpcfg'">
  </ngx-spinner>
  <div *ngIf="!loading" class="flow-container">
    <h3>{{data.action.NAME}}
      <ng-container *ngIf="containsExpression"> - Fluxo: {{idConfig}}  <ng-container *ngIf="configName"> - {{configName}} </ng-container> <ng-container *ngIf="codecompany">- Empresa: {{codecompany}} </ng-container> </ng-container>
    </h3>
    <div class="header-config">
   
      <div>
      <mat-form-field *ngIf="uas.user.companylist.length > 1 && showCodeCompany" class="form-field-density-4 full">
          <mat-label>Escolher uma Empresa</mat-label>
          <mat-select [disabled]="disabled" [(ngModel)]="codecompany" (selectionChange)="getActiveCompanies()">
              <mat-option *ngFor="let data of uas.user.companylist" [value]="data.codecompany">
                  {{data.codecompany}} - {{data.companyname}}
              </mat-option>
          </mat-select>
        </mat-form-field>
      </div>      
      <div >     
        <search-input *ngIf="!containsExpression" class="search-input-dados" [loaddesc]="true" ignoreDefCondition="false" entityname="Mktpcfg" [form]="firstFormGroup"  [condition]="conditionSearch" entitydesc="Mktpcfg" controlname="IDCONF" placeholder="Fluxo" fieldname="NAME" columnname="IDCONF" class="no-padding-form-field"  >
        </search-input>
      </div>
      <button mat-raised-button color="primary" class="btnExec" (click)="executeFlow()" [disabled]="flowRunning">{{flowRunning ? 'Executando...' : 'Executar'}}</button>

      <div class="detail-log mat-elevation-z3">
        <h3 class="h3-padding">Log em Tempo Real</h3>              
        <mat-progress-bar  class="progress" mode="determinate" [value]="getProcessValue()"></mat-progress-bar>
        <p class="status-message">{{statusMessage}}</p>
         <!-- Fluxo Antigo (TYPE=C): log por step via MKTPLGI -->
         <div class="log-container" *ngIf="!isNewMode">
            <mat-card appearance="outlined" class="log-card" *ngFor="let log of logs">
              <mat-card-header (click)="log.expanded = !log.expanded">
                <mat-card-title>{{log.SEQUENCE}}:
                  <ng-container *ngIf="log.NAME">{{log.NAME}} - </ng-container>
                  <ng-container *ngIf="!log.MESSAGE"> Aguardando Processamento </ng-container>
                  {{log.MESSAGE}}
                  <div fxFlex></div>
                  <ng-container><fa-icon  [icon]="log.STATUS=='0'?faCircleNotch:log.STATUS==1?faCheck:faWarning" [spin]="log.STATUS==0" class="rounded-icon"
                    [ngStyle]="log.STATUS==1?{'color':'green'}:log.STATUS==2?{'color':'orange'}:{'color':'black'}"></fa-icon></ng-container>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content *ngIf="log.expanded">                 
                <p><strong>Nro. Job:</strong> {{log.IDJOB}}</p>
                <p><strong>Configuração:</strong> {{log.IDCONF}}</p>
                <p><strong>Ordem de Execução:</strong> {{log.EXECORDER}}</p>
                <p><strong>Requisição:</strong> {{log.REQUEST}}</p>
                <p><strong>Resposta:</strong> {{log.RESPONSE}}</p>
                <p><strong>Modificação:</strong> {{log.RECMODIFYON}}</p>
                <p><strong>Status:</strong> {{log.STATUS}}</p>
                <p><strong>URL:</strong> {{log.URL}}</p>
              </mat-card-content>
            </mat-card>
          </div>
         <!-- Fluxo Novo (TYPE=NM): status geral via FlowServices/jobStatus -->
         <div class="log-container" *ngIf="isNewMode && nmStatus">
            <mat-card appearance="outlined" class="log-card">
              <mat-card-header>
                <mat-card-title>
                  Status: {{nmStatus}}
                  <ng-container *ngIf="nmElapsedMs"> — {{nmElapsedMs}}ms</ng-container>
                  <div fxFlex></div>
                  <fa-icon
                    [icon]="nmStatus === 'COMPLETED' ? faCheck : nmError ? faWarning : faCircleNotch"
                    [spin]="nmStatus === 'RUNNING' || nmStatus === 'PENDING'"
                    class="rounded-icon"
                    [ngStyle]="nmStatus === 'COMPLETED' ? {'color':'green'} : nmError ? {'color':'red'} : {'color':'black'}">
                  </fa-icon>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content *ngIf="nmError && nmErrorMessage">
                <p><strong>Erro:</strong> {{nmErrorMessage}}</p>
              </mat-card-content>
              <mat-card-content *ngIf="nmJobId">
                <p><strong>Job ID:</strong> {{nmJobId}}</p>
              </mat-card-content>
            </mat-card>
          </div>        
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
  <!--button mat-raised-button color="warn" mat-dialog-close>Cancelar</button-->
  <button mat-raised-button color="primary" [mat-dialog-close]="{
  
  }" cdkFocusInitial>Sair</button>
</mat-dialog-actions>

